import { TriggeredReferral } from '@/api/model/triggered-referral'
import { Module } from 'vuex'
import { RootState } from '@/store'
import { actions } from '@/store/triggeredReferrals/actions'
import { mutations } from '@/store/triggeredReferrals/mutations'
import { getters } from '@/store/triggeredReferrals/getters'

export interface TriggeredReferralState {
    loading: boolean,
    error: string|null,
    triggeredReferrals: TriggeredReferral[],
    totalItems: number,
    totalPages: number,
    page: number,
    itemsPerPage: number,
    orderField: string|null,
    orderDirection: string|null,
    activeFilter: number[],
    companyFilter: string|null,
    nameFilter: string|null,
}

const state: TriggeredReferralState = {
    loading: false,
    error: null,
    triggeredReferrals: [],
    totalItems: 0,
    totalPages: 0,
    page: 1,
    itemsPerPage: 12,
    orderField: null,
    orderDirection: null,
    activeFilter: null,
    companyFilter: null,
    nameFilter: null,
}

export const TriggeredReferralModule: Module<TriggeredReferralState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
